import clsx from "clsx";
import { useI18nContext } from "../../../contexts/I18nContext";
import { useUserContext } from "../../../contexts/UserContext";
import { useStyles } from "../ReferenceItemPrice.style";
import ShowText from "../../../shared_components/Info/ShowText/ShowText";
import ExpandoMenu from "../../../ui_components/ExpandoMenu/ExpandoMenu";
import Access from "../../../shared_components/Access/AllowAccess/Access";
import ReferenceItemPriceRowProperties from "./ReferenceItemPriceRowProperties";

const ReferenceItemPriceRowSmall: React.FC<ReferenceItemPriceRowProperties> = ({
                                                                                  referenceItemPriceResponse,
                                                                                  className,
                                                                                  filter,
                                                                                  onUpdate,
}) => {
  const classes = useStyles();
  const i18n = useI18nContext();
  const userStore = useUserContext();

  return (
    <div className={clsx(classes.reference_items_info_container)}>
      <ShowText
        title={i18n.translate("NAME")}
        text={referenceItemPriceResponse.referenceItemName}
        textToHighlight={filter}
      />
      {(userStore.hasAccess(Access.CREATE_EDIT_REFERENCE_ITEM_PRICE) ||
        userStore.hasAccess(Access.REMOVE_REFERENCE_ITEM_PRICE)) && (
        <ExpandoMenu>
          <>
            {/*  {userStore.hasAccess(Access.CREATE_EDIT_REFERENCE_ITEM) &&
                                <NewInventoryItemButton
                                    type={ButtonType.SECONDARY}
                                    onSave={onUpdate}
                                    inventoryItemId={inventoryItem.id}
                                    size={ButtonSize.SMALL}
                                    showText/>
                            }
                            <RemoveInventoryItemButton
                                type={ButtonType.SECONDARY}
                                onSave={onUpdate}
                                inventoryItem={inventoryItem}
                                size={ButtonSize.SMALL}/> */}
          </>
        </ExpandoMenu>
      )}
    </div>
  );
};
export default ReferenceItemPriceRowSmall;
